module.exports = __webpack_public_path__ + "img/b_firstbankofnigeria@2x.f90fbf6f.png";